export const GENERATE_FINAL_CHARGES_REQUEST = "GENERATE_FINAL_CHARGES_REQUEST";
export const GENERATE_FINAL_CHARGES_SUCCESS = "GENERATE_FINAL_CHARGES_SUCCESS";
export const GENERATE_FINAL_CHARGES_FAILURE = "GENERATE_FINAL_CHARGES_FAILURE";
export const GENERATE_FINAL_CHARGES_RESET = "GENERATE_FINAL_CHARGES_RESET";
export const generateFinalChargesRequest = (payload) => ({
    type: GENERATE_FINAL_CHARGES_REQUEST,
    payload,
});
export const generateFinalChargesSuccess = (payload) => ({
    type: GENERATE_FINAL_CHARGES_SUCCESS,
    payload,
});
export const generateFinalChargesFailure = (error) => ({
    type: GENERATE_FINAL_CHARGES_FAILURE,
    payload: error,
});
export const generateFinalChargesReset = () => ({
    type: GENERATE_FINAL_CHARGES_RESET,
});
